import React, { Component } from 'react'
import { Form, Row, Col, Alert, InputGroup } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import { withTranslation } from 'react-i18next'
import { observable, makeObservable, action } from 'mobx'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { isNumeric } from '../../../../utils/objectutils'
import VariantView from '../VariantView'
import { colors } from '../../../../styles/colors'
import { getMetaProperty } from '../../../../utils/customerPrototypes'

const StyledWrapper = styled.div`
  padding: 10px;
  flex-grow: 1;
  border-bottom: 1px solid ${colors.gray3};
`
class PositionItem extends Component {
  validationError = null
  quantityCounted = null
  oldValue = null
  enforceUpdate = false
  constructor(props) {
    super(props)

    makeObservable(this, {
      validationError: observable,
      quantityCounted: observable,
      oldValue: observable,
      enforceUpdate: observable,
      init: action,
      setPropValue: action,
    })

    this.init()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { position } = this.props
    if (
      !!this.enforceUpdate ||
      (!!prevProps && this.positionHasChanged(prevProps.position, position))
    ) {
      this.init()
    }
  }
  init = () => {
    const { position } = this.props
    this.quantityCounted = position.quantityCounted
    this.enforceUpdate = false
  }
  positionHasChanged = (oldPosition, newPosition) => {
    const oldPositionsString = JSON.stringify(oldPosition)
    const newPositionsString = JSON.stringify(newPosition)
    return oldPositionsString !== newPositionsString
  }
  getValidationInfo = () => {
    const { position } = this.props
    const { validation } = position
    let msg = null
    let errorDetails = []

    if (validation) {
      validation.forEach((error) => {
        switch (error.source) {
          default:
            break
        }
      })
    }
    if (errorDetails.length) {
      msg = errorDetails.join('\n\n')
    }
    return msg
  }
  fieldIsDisabled = (name) => {
    const { position } = this.props
    let disabled = false
    switch (name) {
      case 'articleVariant':
      case 'article':
      case 'quantityCounted':
        disabled = getMetaProperty(
          position.metaProperties,
          `/${name}`,
          'isReadOnly'
        )
        break
      default:
        break
    }
    return !!disabled
  }
  handleOnFocus = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnFocus", value, e, id)
    e.preventDefault()
    switch (name) {
      case 'quantityCounted':
        this.updateQuantityChanges('oldValue', value)
        break
      default:
        break
    }
  }
  handleOnBlur = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnBlur", value, e, id)
    switch (name) {
      case 'quantityCounted':
        this.updateQuantityChanges(name, value, this.oldValue, true)
        break
      default:
        break
    }
  }
  handleOnChange = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnChange", value, e, id)
    switch (name) {
      case 'quantityCounted':
        this.updateQuantityChanges(name, value)
        break
      default:
        break
    }
  }
  handleOnKeyDown = async (e) => {
    if (e.key === 'Enter') {
      const { handleNextFocus } = this.props
      const { value, id, name } = e.target
      e.preventDefault() //ENTER key on keyboard and page refreshes
      switch (name) {
        case 'quantityCounted':
          this.updateQuantityChanges(name, value, this.oldValue, true)
          handleNextFocus(id, name)
          break
        default:
          break
      }
    }
  }
  setPropValue = (name, value) => {
    this[name] = value
  }
  updateQuantityChanges = async (
    name,
    value,
    defVal = '',
    updatePosition = false
  ) => {
    const { position } = this.props
    let isValid = false
    let validValue = defVal
    if (isNumeric(value)) {
      validValue = parseInt(value)
      isValid = validValue >= 0 && position.freeQuantity >= validValue && position.quantityExpected >= validValue
    }
    if (!isValid) {
      validValue = defVal
    }
    switch (name) {
      case 'quantityCounted':
      default:
        this.setPropValue(name, validValue)
        break
    }
    if (!!updatePosition) {
      this.changePositionByKey(name, value)
    }
    //console.log("updateQuantityChanges", value, isNumeric(value), this[name], name, validValue)
  }
  updateKeyChanges = async (name, value) => {
    this.changePositionByKey(name, value)
  }
  changePositionByKey = async (name, value) => {
    const { position, index, handleChangePositionByKey, resetErrorByFormKey } =
      this.props
    handleChangePositionByKey(position.id, name, value)
    resetErrorByFormKey(`positions${index}${name}`)
  }
  renderVariantView() {
    const { position, index, formErrors } = this.props
    const { article, articleVariant } = position
    return (
      <VariantView
        articleId={article.id}
        selectedVariant={articleVariant}
        disabled={true/*this.fieldIsDisabled('articleVariant')*/}
        handleOnChange={this.handleOnChangeVariant}
        formError={formErrors[`positions${index}articleVariant`]}
      />
    )
  }
  getQuantityInputStyle() {
    const { position } = this.props
    if (!position.freeQuantity) {
      return { color: colors.black, backgroundColor: '#ffbbbb' }
    } else if (position.freeQuantity >= position.quantityExpected) {
      return { color: colors.black, backgroundColor: '#c9e9cd' }
    } else {
      return { color: colors.black, backgroundColor: '#ffff9d' }
    }
  }
  renderStockQuantities(){
    const { position, t} = this.props
    return (
      <>
        <InputGroup className='m-0' style={{ width: '100px' }}>
          <InputGroup.Text
            id='stock'
            style={this.getQuantityInputStyle()}
          >
            {position.freeQuantity} {t('of')} {position.quantityOnStock} {t('picking:available')}
          </InputGroup.Text>
        </InputGroup>
      </>
    )
  }
  renderQuantityCounted() {
    const { position, index, formErrors } = this.props
    const disabled = this.fieldIsDisabled('quantityCounted')
    const formError = formErrors[`positions${index}quantityCounted`]
    return (
      <>
        <InputGroup className='m-0' style={{ width: '100px' }}>
          <Form.Control
            id={`${position.id}-qc_${index}`}
            name='quantityCounted'
            type='number'
            value={this.quantityCounted}
            onChange={this.handleOnChange}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onKeyDown={this.handleOnKeyDown}
            min={0}
            max={position.quantityExpected}
            isInvalid={!!formError}
            disabled={!!disabled}
          />
          <InputGroup.Text
            id='basic-addon2'
            style={this.getQuantityInputStyle()}
          >
            /{position.quantityExpected}
          </InputGroup.Text>
          <Form.Control.Feedback type='invalid'>
            {formError}
          </Form.Control.Feedback>
        </InputGroup>
      </>
    )
  }
  renderHeader(title) {
    return <div className='fw-bold'>{title}</div>
  }
  renderTableItem() {
    const { position, isControl } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()
    return (
      <>
        <tr>
          <td>
            {!!position.isNewPosition && '* '}
            {article.articleNumber}
          </td>
          <td>{article.displayName}</td>
          <td>
            {!!article.isWithSizes && this.renderVariantView()}
            {!article.isWithSizes && <div>---</div>}
          </td>
          <td>
            {this.renderQuantityCounted()}
          </td>
          {!isControl && <td>
            {this.renderStockQuantities()}
          </td>}
        </tr>
        {this.validationError && (
          <tr>
            <td colSpan='4'>
              <Alert variant='danger' className='mb-3'>
                {this.validationError}
              </Alert>
            </td>
          </tr>
        )}
        {validationInfo && (
          <tr>
            <td colSpan='4'>
              <Alert variant='info' className='mb-3'>
                {validationInfo}
              </Alert>
            </td>
          </tr>
        )}
      </>
    )
  }
  renderListItem() {
    const { t, position } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()
    return (
      <React.Fragment>
        <StyledWrapper>
          <Row>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('productDetail:articleNumber'))}
              <div>
                {article.articleNumber}
              </div>
            </Col>
            <Col lg='3' sm='3'>
              {this.renderHeader(t('productDetail:articleDescription'))}
              <div>{article.displayName}</div>
            </Col>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('size'))}
              {!!article.isWithSizes && this.renderVariantView()}
              {!article.isWithSizes && <div>---</div>}
            </Col>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('goodsReceiptPage:quantityExpected'))}
              {this.renderQuantityCounted()}
            </Col>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('picking:quantityOnStock'))}
              {this.renderStockQuantities()}
            </Col>
          </Row>
          {this.validationError && (
            <Alert variant='danger' className='mb-3'>
              {this.validationError}
            </Alert>
          )}
          {validationInfo && (
            <Alert variant='info' className='mb-3'>
              {validationInfo}
            </Alert>
          )}
        </StyledWrapper>
      </React.Fragment>
    )
  }

  render() {
    const { enforceListView } = this.props
    return (
      <>
        {!!enforceListView ? (
          this.renderListItem()
        ) : (
          <>
            {<MediaQuery maxWidth={998}>{this.renderListItem()}</MediaQuery>}
            {<MediaQuery minWidth={999}>{this.renderTableItem()}</MediaQuery>}
          </>
        )}
      </>
    )
  }
}

export default withTranslation()(observer(PositionItem))
